import firebase from "firebase/app"

export interface RoomMemberData {
  id: string;
  name: string;
  ready: boolean;
}

const INITIAL_ROOM_MEMBER_DATA: RoomMemberData = {
  id: '',
  name: '',
  ready: false
}

export class RoomMember {
  public data = INITIAL_ROOM_MEMBER_DATA
  public roomId: string

  constructor (roomId: string, data: RoomMemberData) {
    this.roomId = roomId
    this.data = data
  }

  private get roomDocRef () {
    return firebase.firestore().doc(`room/${this.roomId}`)
  }

  public get id (): string {
    return this.data.id
  }

  public get name (): string {
    return this.data.name
  }

  public set name (name: string) {
    this.data.name = name
  }

  public set ready (ready: boolean) {
    this.data.ready = ready
  }

  
  public get ready () {
    return this.data.ready
  }

  public async updateName (name: string): Promise<void> {
    this.name = name
    this.updateMember()
    await this.updateRoom('name', name)
  }

  public async setReady (val: boolean): Promise<void> {
    this.data.ready = val
    await this.updateRoom('ready', val)
  }

  private async updateRoom (fieldKey: string, value: string | number | boolean | []): Promise<void> {
    const key = `members.${this.id}.${fieldKey}`
    await this.roomDocRef.update({
      [key]: value
    })
  }

  private async updateMember () {
    await this.roomMemberDocRef.update(this.data)
  }

  private get roomMemberDocRef (): firebase.firestore.DocumentReference {
    return firebase.firestore().doc(`room/${this.roomId}/member/${this.id}`)
  }

  public get url (): string {
    return `${location.protocol}//${location.host}/room/${this.roomId}/player/${this.id}`
  }
}
